//
import ExtendModel from '@/models/ExtendModel'

//
import DetailPurchaseOrder from '@/models/Purchase/PchDetailPurchaseOrder'

/**
 * @class
 */
export default class WhProductService extends ExtendModel {

    /**
     * { item_description }
     */
    static appends = [
        'provider_code',
    ]

    /**
     * @description
     * api endpoint
     */
    resource() {
        return 'wh_product_service'
    }

    /**
     * @description
     * create data params structure
     */
    toCreate() {
        return this.clean(['name', 'is_cyclic'])
    }

    /**
     * @description
     * cast to detail purchase order
     */
    toDetailPurchaseOrder() {
        //
        this.wh_product_service = this
        this.wh_product_service_id = this.id

        //
        this.net_price = 1
        this.provider_product_code = this.provider_code || ''
        this.quantity = 1
        this.received = 0

        //
        return new DetailPurchaseOrder(
            this.clean([
                'id',
                'net_price',
                'provider_product_code',
                'quantity',
                'received',
                'wh_product_service',
                'wh_product_service_id'
            ])
        )
    }

    /**
     * @description
     * selected data structure
     */
    toSelected() {
        //
        this.wh_product_service = this

        //
        this.quantity = 1
        this.provider_product_code = this.last_provider_code || ''
        this.net_price = 1

        //
        return new DetailPurchaseOrder(
            this.clean([
                'id',
                'net_price',
                'provider_product_code',
                'quantity',
                'wh_product_service'
            ])
        )
    }
}
